// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__nGk1M","tab":"Tabs_tab__pRobv","tabActive":"Tabs_tabActive__j6Joi","tabPanelHidden":"Tabs_tabPanelHidden__FXGEN"};